import React from "react";
import { Link } from "react-router-dom";
import api from "../../Environment";
import Helper from "../Helper/helper";
import ToastDemo from "../Helper/toaster";
import { translate, t } from "react-multi-lang";
import configuration from "react-global-configuration";
import { CopyToClipboard } from "react-copy-to-clipboard";
import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  EmailShareButton,
  RedditShareButton,
  FacebookIcon,
  TwitterIcon,
  WhatsappIcon,
  EmailIcon,
  RedditIcon,
} from "react-share";
import {
  getReferralPageConfig,
  isExternalHref,
} from "../Helper/siteContent";
import { normalizeExternalUrl } from "../Helper/urls";
import BrandLinksRow from "../Helper/BrandLinksRow";

const $ = window.$;

class ReferalFriend extends Helper {
  state = {
    data: {
      referral_code: "",
      referrals_signup_url: "",
      total_referrals: 0,
      referral_earnings_formatted: 0,
    },
    referralPage: getReferralPageConfig(),
  };

  componentDidMount() {
    this.setState({ referralPage: getReferralPageConfig() });
    this.getReferralDetails();
  }

  onCopy = () => {
    this.setState({ copied: true });

    $("#referral_copy_success")
      .html("copied")
      .fadeIn("slow");

    setTimeout(function() {
      $("#referral_copy_success").html("");
    }, 1000);
  };

  getReferralDetails = () => {
    api
      .postMethod("referral_code")
      .then((response) => {
        if (response.data.success) {
          this.setState({
            data: response.data.data,
            loading: false,
          });
        } else if (response.data.error) {
          ToastDemo(this.props.toastManager, response.data.error, "error");
        }
      })
      .catch((error) => {
        this.setState({ loadingContent: null, buttonDisable: false });
        if (error) {
          ToastDemo(this.props.toastManager, error, "error");
        }
      });
  };

  renderCmsLink = (label, url, key) => {
    if (!label || !url) {
      return null;
    }
    if (isExternalHref(url)) {
      return (
        <a
          key={key}
          href={normalizeExternalUrl(url)}
          className="referal-footer-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          {label}
        </a>
      );
    }
    return (
      <Link key={key} to={url} className="referal-footer-link">
        {label}
      </Link>
    );
  };

  render() {
    const { data, referralPage } = this.state;
    const siteName = configuration.get("configData.site_name");
    const heroImage =
      (referralPage && referralPage.hero_image) ||
      window.location.origin + "/assets/img/referal-friend-chat.svg";
    const heroTitle =
      (referralPage && referralPage.hero_title) ||
      `${t("tell_friends_about")} ${siteName}`;
    const primaryCta =
      (referralPage && referralPage.primary_cta_label) || t("copy_link");
    const instructions = referralPage && referralPage.instructions;
    const richContent = referralPage && referralPage.rich_content;
    const footerLinks = [
      {
        label: referralPage.privacy_link_label,
        url: referralPage.privacy_link_url,
        key: "privacy",
      },
      {
        label: referralPage.terms_link_label,
        url: referralPage.terms_link_url,
        key: "terms",
      },
      {
        label: referralPage.referral_terms_link_label,
        url: referralPage.referral_terms_link_url,
        key: "referral-terms",
      },
      {
        label: referralPage.custom_link_1_label,
        url: referralPage.custom_link_1_url,
        key: "custom-1",
      },
      {
        label: referralPage.custom_link_2_label,
        url: referralPage.custom_link_2_url,
        key: "custom-2",
      },
    ].filter((link) => link.label && link.url);

    return (
      <div>
        <div className="bg-color-white referal padding-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h1>
                  <img
                    src={heroImage}
                    alt=""
                    className="referal-head-icon"
                  />
                  <div className="title">{heroTitle}</div>
                </h1>
                {referralPage.hero_subtitle ? (
                  <h3 className="sub-title">{referralPage.hero_subtitle}</h3>
                ) : null}
                {referralPage.hero_description ? (
                  <p className="description">{referralPage.hero_description}</p>
                ) : null}
                <hr className="border-thick"></hr>
              </div>
            </div>

            {richContent ? (
              <div className="row">
                <div className="col-md-12">
                  {String(richContent)
                    .split(/\n+/)
                    .map((paragraph, index) => (
                      <p key={`referral-rich-${index}`}>{paragraph}</p>
                    ))}
                </div>
              </div>
            ) : null}

            <div className="referal-sub-sec">
              <div className="row">
                <div className="col-md-12">
                  <div className="">
                    <h2 className="sub-title">{t("referral_code_note")}</h2>
                    <h5 className="description">{data.referrals_signup_note}</h5>
                  </div>
                </div>
              </div>
              <div className="referal-sub-div">
                <div className="row">
                  <div className="col-md-6 resp-width">
                    <div className="referal-email">
                      <div className="input-group mb-3">
                        <input
                          type="text"
                          className="form-control"
                          disabled
                          placeholder={data.referrals_signup_url}
                        />
                        <div className="input-group-append">
                          <span className="input-group-text">
                            <CopyToClipboard
                              onCopy={this.onCopy}
                              text={data.referrals_signup_url}
                            >
                              <button className="btn btn-referal theme-btn-primary" type="button">
                                {primaryCta}
                              </button>
                            </CopyToClipboard>
                          </span>
                        </div>
                      </div>
                      {referralPage.secondary_cta_label &&
                      referralPage.secondary_cta_url ? (
                        <div className="mb-3">
                          {isExternalHref(referralPage.secondary_cta_url) ? (
                            <a
                              className="btn btn-outline-secondary"
                              href={normalizeExternalUrl(
                                referralPage.secondary_cta_url
                              )}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {referralPage.secondary_cta_label}
                            </a>
                          ) : (
                            <Link
                              className="btn btn-outline-secondary"
                              to={referralPage.secondary_cta_url}
                            >
                              {referralPage.secondary_cta_label}
                            </Link>
                          )}
                        </div>
                      ) : null}
                      <p
                        id="referral_copy_success"
                        className="text-success"
                      ></p>
                    </div>
                  </div>
                  <div className="col-md-6 resp-width resp-mrg-btm">
                    <div className="row resp-mrg-btm-1">
                      <div className="col-md-2 border-right-1 resp-width resp-no-border resp-mrg-btm">
                        <div className="text-center alternative-social">
                          <h2 className="social-desc big">Or</h2>
                        </div>
                      </div>
                      <div className="col-md-2 border-right-1 resp-width-1 resp-width-5 flex-box-content">
                        <div className="text-center social-link">
                          <div className="Demo__some-network">
                            <EmailShareButton
                              subject={configuration.get(
                                "configData.site_name"
                              )}
                              body={data.share_message}
                              className="Demo__some-network__share-button"
                            >
                              <EmailIcon size={32} round />
                            </EmailShareButton>
                          </div>
                          <h2 className="social-desc">{t("email")}</h2>
                        </div>
                      </div>
                      <div className="col-md-2 border-right-1 resp-width-1 resp-width-5 flex-box-content">
                        <div className="text-center social-link">
                          <WhatsappShareButton
                            url={data.referrals_signup_url}
                            title={data.share_message}
                            separator=":: "
                            className="Demo__some-network__share-button"
                          >
                            <WhatsappIcon size={32} round />
                          </WhatsappShareButton>
                          <h2 className="social-desc">{t("whatsapp")}</h2>
                        </div>
                      </div>
                      <div className="col-md-2 border-right-1 resp-width-1 resp-width-5 flex-box-content">
                        <div className="text-center social-link">
                          <FacebookShareButton
                            url={data.referrals_signup_url}
                            quote={data.share_message}
                            className="Demo__some-network__share-button"
                          >
                            <FacebookIcon size={32} round />
                          </FacebookShareButton>
                          <h2 className="social-desc">{t("facebook")}</h2>
                        </div>
                      </div>
                      <div className="col-md-2 border-right-1 resp-width-1 resp-width-5 flex-box-content">
                        <div className="text-center social-link">
                          <TwitterShareButton
                            url={data.referrals_signup_url}
                            title={data.share_message}
                            className="Demo__some-network__share-button"
                          >
                            <TwitterIcon size={32} round />
                          </TwitterShareButton>
                          <h2 className="social-desc">X</h2>
                        </div>
                      </div>
                      <div className="col-md-2 border-right-1 resp-width-1 resp-width-5 flex-box-content">
                        <div className="text-center social-link">
                          <RedditShareButton
                            url={data.referrals_signup_url}
                            title={data.share_message}
                            windowWidth={660}
                            windowHeight={460}
                            className="Demo__some-network__share-button"
                          >
                            <RedditIcon size={32} round />
                          </RedditShareButton>
                          <h2 className="social-desc">{t("reddit")}</h2>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row mt-3 mb-3">
                <div className="col-md-12">
                  <BrandLinksRow placement="referral_page" />
                </div>
              </div>
              <div className="row referal-count">
                <div className="col-md-6 resp-width">
                  <p className="desc mt-3">
                    <span>{t("total_referrals")}</span>
                    <strong>
                      <span className="float-right">
                        {data.total_referrals}
                      </span>
                    </strong>
                  </p>
                  <p className="desc no-margin">
                    {t("referral_earnings")}
                    <strong>
                      <span className="float-right">
                        {data.referral_earnings_formatted}
                      </span>
                    </strong>
                  </p>
                  <p className="desc no-margin">
                    {t("referee_earnings")}
                    <strong>
                      <span className="float-right">
                        {data.referee_earnings_formatted}
                      </span>
                    </strong>
                  </p>
                  <p className="desc no-margin">
                    {t("total_credits")}
                    <strong>
                      <span className="float-right">
                        {data.currency}
                        {data.amount_total ? data.amount_total : 0}
                      </span>
                    </strong>
                  </p>
                  <p className="desc no-margin">
                    {t("used_credits")}
                    <strong>
                      <span className="float-right">
                        {data.currency}
                        {data.amount_used ? data.amount_used : 0}
                      </span>
                    </strong>
                  </p>
                  <p className="desc no-margin">
                    {t("remaining_credits")}
                    <strong>
                      <span className="float-right">
                        {data.currency}
                        {data.remaining ? data.remaining : 0}
                      </span>
                    </strong>
                  </p>
                  <p className="desc no-margin">
                    {t("pending_credits")}
                    <strong>
                      <span className="float-right">
                        {data.currency}
                        {data.onhold ? data.onhold : 0}
                      </span>
                    </strong>
                  </p>
                </div>
              </div>
            </div>

            {instructions ? (
              <div className="referal-sub-head">
                <h3 className="sub-head">{t("how_it_works_referral")}</h3>
                {String(instructions)
                  .split(/\n+/)
                  .map((paragraph, index) => (
                    <p key={`referral-instructions-${index}`}>{paragraph}</p>
                  ))}
              </div>
            ) : (
              <>
                <div className="referal-sub-head">
                  <h3 className="sub-head">{t("how_it_works_referral")}</h3>
                </div>
                <div className="row pt-45">
                  <div className="col-md-4 resp-mrg-btm-1">
                    <div className="referal-box">
                      <div className="referal-icon">
                        <img
                          src={
                            window.location.origin +
                            "/assets/img/share-referal.svg"
                          }
                          alt=""
                          className="referal-head-icon"
                        />
                      </div>
                      <div className="referal-info">
                        <h4 className="referal-info-title">
                          {t("referral_step1")}
                        </h4>
                        <p className="referal-info-desc">
                          {t("referral_step1_content")}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="referal-arrow">
                    <i className="fas fa-chevron-right"></i>
                  </div>
                  <div className="col-md-4 resp-mrg-btm-1">
                    <div className="referal-box">
                      <div className="referal-icon">
                        <img
                          src={
                            window.location.origin +
                            "/assets/img/referal-friend.svg"
                          }
                          alt=""
                          className="referal-head-icon"
                        />
                      </div>
                      <div className="referal-info">
                        <h4 className="referal-info-title">
                          {t("referral_step2")}
                        </h4>
                        <p className="referal-info-desc">
                          {t("referral_step2_content")}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="referal-arrow-1">
                    <i className="fas fa-chevron-right"></i>
                  </div>
                  <div className="col-md-4">
                    <div className="referal-box">
                      <div className="referal-icon">
                        <img
                          src={
                            window.location.origin + "/assets/img/message.svg"
                          }
                          alt=""
                          className="referal-head-icon"
                        />
                      </div>
                      <div className="referal-info">
                        <h4 className="referal-info-title">
                          {t("referral_step3")}
                        </h4>
                        <p className="referal-info-desc">
                          {t("referral_step3_content")}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}

            <hr className="border-thin"></hr>
            <div className="referal-footer">
              {footerLinks.length
                ? footerLinks.map((link, index) => (
                    <span key={link.key}>
                      {index > 0 ? " · " : ""}
                      {this.renderCmsLink(link.label, link.url, link.key)}
                    </span>
                  ))
                : null}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default translate(ReferalFriend);
